import Header from "./Compartido/Header";
import HeroSection from "./ListaBlog/HeroSection";
import ListaNoticias from "./ListaBlog/ListaNoticias";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";

const ListaBlog = (props) => {
    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <HeroSection
                    ruta={props.ruta}
                />
            </main>
            <ListaNoticias
                noticias={props.noticias}
                ruta={props.ruta}
                lang={props.lang}
                config={props.websgrupo}
            />
            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}

export default ListaBlog
